import script from "./AboutDetailSection.vue?vue&type=script&setup=true&lang=js"
export * from "./AboutDetailSection.vue?vue&type=script&setup=true&lang=js"

import "./AboutDetailSection.vue?vue&type=style&index=0&id=32056688&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32056688"]])

export default __exports__